const header = [
            { title: "General Condition", description: "General condition of vehicle" },
            { title: "Exterior Condition", description: "Is secure and in good working order" },
            { title: "Cranes and Lifting Equipment", description: "Is secure and in good working order" },
            { title: "Power Train System", description: "Is secure and in good working order" },
            { title: "Attachments", description: "Is secure and in good working order" },
            { title: "Drive Train", description: "Is secure and in good working order" },
            { title: "Controls", description: "Is secure and in good working order" },
            { title: "Warning Devices", description: "Is secure and in good working order" },
            { title: "Administration", description: "Is secure and in good working order" },
            { title: "Interior Condition", description: "Is secure and in good working order" },
            { title: "Other", description: "Is secure and in good working order" },
        ]

export default header;